module.exports = __webpack_public_path__ + "static/media/arizona.ffd2a796.jpg";